import '../applied_text_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedGenericUserView extends Monitoring.Views.SocialContents.Filters.AppliedTextView
  initialize: ({searchQuery}) ->
    super
      searchQuery: searchQuery
      title: I18n.t('monitoring.dashboard.filters.filter_names.users.name')
      fieldName: 'general_users'

  removeText: (event) =>
    user = $(event.target).parent().find('.user').text()
    @searchQuery.removeGeneralUser(user)
    @_triggerQueryChanged()
